
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Role = {
  MANAGER: 'MANAGER',
  SUPER_MANAGER: 'SUPER_MANAGER',
  CUSTOMER_SERVICE_REP: 'CUSTOMER_SERVICE_REP',
  INSIDE_SALES_REP: 'INSIDE_SALES_REP',
  OUTSIDE_SALES_REP: 'OUTSIDE_SALES_REP',
  OTHER: 'OTHER'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const CreatedVia = {
  WEBAPP: 'WEBAPP',
  PUBLIC_API: 'PUBLIC_API'
} as const

export type CreatedVia = (typeof CreatedVia)[keyof typeof CreatedVia]


export const CrmNoteType = {
  NOTE: 'NOTE',
  VISIT: 'VISIT',
  PHONE_CALL: 'PHONE_CALL'
} as const

export type CrmNoteType = (typeof CrmNoteType)[keyof typeof CrmNoteType]


export const CrmTaskStatus = {
  OPEN: 'OPEN',
  COMPLETED: 'COMPLETED'
} as const

export type CrmTaskStatus = (typeof CrmTaskStatus)[keyof typeof CrmTaskStatus]


export const InsInsightOutcomeStatus = {
  RESOLVED: 'RESOLVED',
  NOT_RELEVANT: 'NOT_RELEVANT'
} as const

export type InsInsightOutcomeStatus = (typeof InsInsightOutcomeStatus)[keyof typeof InsInsightOutcomeStatus]


export const InsInsightOutcomeResponse = {
  INTERESTED: 'INTERESTED',
  NO_NEED: 'NO_NEED',
  BUYS_ELSEWHERE: 'BUYS_ELSEWHERE',
  INCORRECT: 'INCORRECT',
  NORMAL: 'NORMAL'
} as const

export type InsInsightOutcomeResponse = (typeof InsInsightOutcomeResponse)[keyof typeof InsInsightOutcomeResponse]
